<template>
  <div class="point-pool" :style="customStyle">
    <generic-html :component="htmlComponent" />
  </div>
</template>

<script>
import _ from 'lodash'
import {mapActions} from 'vuex'
import GenericHtml from '@/components/generic/GenericHtml'

export default {
  components: {
    GenericHtml,
  },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      htmlComponent: {},
      relationships: [],
    }
  },
  computed: {
    pointPoolId() {
      return _.get(this.data, 'point_pool_id', '')
    },
    text() {
      return _.get(this.data, 'text', '')
    },
    customTagStyles() {
      return _.get(this.data, 'customTagStyles', {})
    },
    customStyle() {
      return _.get(this.data, 'style', {})
    },
    pointPoolRelationshipByPointPoolId() {
      return this.relationships.find((relationship) => {
        return _.get(relationship, 'point_pool.id') === this.pointPoolId
      })
    },
    points() {
      return _.defaultTo(
        _.get(this.pointPoolRelationshipByPointPoolId, 'points', 0), 0
      ).toLocaleString()
    },
    mappedText() {
      if (this.text) {
        return this.text.replace('{{point_pool_points}}', this.points)
      }

      return ''
    },
  },
  created() {
    this.fetchPoolPoints()
    this.$set(
      this.htmlComponent, 'customTagStyles', this.customTagStyles
    )
  },
  methods: {
    ...mapActions(['fetchPointPoolRelationships']),
    async fetchPoolPoints() {
      if (this.pointPoolId) {
        try {
          this.relationships = await this.fetchPointPoolRelationships()
          this.$set(this.htmlComponent, 'html', this.mappedText)
        } catch (error) {
          console.log(error)
        }
      }
    }
  },
}
</script>

<style lang="scss" scoped></style>
